import { useEffect } from "react";

export function useNavigationListener(onNavigationClick: () => void) {
  useEffect(() => {
    const handlePopState = () => {
      onNavigationClick();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [onNavigationClick]);
}
